import React from 'react'
import logo from '../../assets/w2m2.png';

const Logo = () => {
  return (
    <div className="hands">
            <img className='landing-image' src={logo} alt="hands"/>
        </div>
  )
}

export default Logo